/* global angular*/
import './style.less';

export default function($log) {
  'ngInject';

  const vm = this;

  vm.remove = i => vm.ngModel.splice(i, 1);

  vm.addTextArea = () => {
    if (!vm.ngModel) vm.ngModel = [];
    const id = `${vm.ngModel.length + 1}_text_area`;
    const text_area = {
      disabled: false,
      id,
      name: undefined,
      required: true
    };
    vm.ngModel.push(angular.copy(text_area));
  };
}



// WEBPACK FOOTER //
// ./src/app/components/forms/paragraphResponses/input/controller.js